// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * VoicemailConfigService manages voicemail boxes
 * NWX endpoints - location-ids represent optional labels on voicemail boxes to filter by
 */
export const VoicemailConfigService = {
    /**
     * Create voicemail box with all configuration options including optional extension
     * POST: /phone/voicemail-config/v2
     */
    Create(fn, req) {
        return fn(`/phone/voicemail-config/v2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Read voicemail box
     * GET: /phone/voicemail-config/v2/{voicemail_box_id}
     */
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailBoxId"], "voicemailBoxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/${req["voicemailBoxId"]}?${fm.renderURLSearchParams(req, ["voicemailBoxId"])}`, { method: "GET" });
    },
    /**
     * List voicemail boxes, any associated extension, location(s) assigned to, and if it's shared in the app or not
     * GET: /phone/voicemail-config/v2/voicemailboxes?{tenant-id}
     */
    List(fn, req) {
        return fn(`/phone/voicemail-config/v2/voicemailboxes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Update voicemail box includes adding/removing an extension or sharing a voicemail box across locations
     * PUT: /phone/voicemail-config/v2/
     */
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailBoxId"], "voicemailBoxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/${req["voicemailBoxId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Delete voicemail box
     * DELETE: /phone/voicemail-config/v2/{voicemail_box_id}
     */
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailBoxId"], "voicemailBoxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/${req["voicemailBoxId"]}?${fm.renderURLSearchParams(req, ["voicemailBoxId"])}`, { method: "DELETE" });
    },
    /**
     * Lists available extensions on the tenant
     * GET: /phone/voicemail-config/v2/extensions?{tenant-id}
     */
    ListExtensions(fn, req) {
        return fn(`/phone/voicemail-config/v2/extensions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Usage returns where the voicemail box is being used. Returns empty if not being used.
     * GET: /phone/voicemail-config/v2/{voicemail_box_id}/usage
     */
    Usage(fn, req) {
        try {
            fm.validateUrlParam(req["voicemailBoxId"], "voicemailBoxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/${req["voicemailBoxId"]}/usage?${fm.renderURLSearchParams(req, ["voicemailBoxId"])}`, { method: "GET" });
    },
    /**
     * CreateGreetingFromMedia creates a mailbox greeting using an existing media item from the Media Library
     */
    CreateGreetingFromMedia(fn, req) {
        try {
            fm.validateUrlParam(req["mailboxId"], "mailboxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/${req["mailboxId"]}/greetings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ListGreetings returns a list of mailbox greetings for a mailbox.
     */
    ListGreetings(fn, req) {
        try {
            fm.validateUrlParam(req["mailboxId"], "mailboxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/${req["mailboxId"]}/greetings?${fm.renderURLSearchParams(req, ["mailboxId"])}`, { method: "GET" });
    },
    /**
     * UpdateGreeting updates greeting settings for a given mailbox greeting.
     */
    UpdateGreeting(fn, req) {
        try {
            fm.validateUrlParam(req["greetingId"], "greetingId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/greetings/${req["greetingId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeleteGreeting deletes a mailbox greeting.
     */
    DeleteGreeting(fn, req) {
        try {
            fm.validateUrlParam(req["greetingId"], "greetingId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/greetings/${req["greetingId"]}?${fm.renderURLSearchParams(req, ["greetingId"])}`, { method: "DELETE" });
    },
    /**
     * UpdateMailboxGreetings performs an update for all greetings of a mailbox.
     */
    UpdateMailboxGreetings(fn, req) {
        try {
            fm.validateUrlParam(req["mailboxId"], "mailboxId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v2/greetings/${req["mailboxId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
